import { render, staticRenderFns } from "./EmptyPage.vue?vue&type=template&id=a50f6942&scoped=true"
import script from "./EmptyPage.vue?vue&type=script&lang=js"
export * from "./EmptyPage.vue?vue&type=script&lang=js"
import style0 from "./EmptyPage.vue?vue&type=style&index=0&id=a50f6942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50f6942",
  null
  
)

export default component.exports